import React from 'react';

import { safeDimension } from '../../lib/attachments';

import { ImageFrame } from '../ImageFrame';

const PdfAttachment = ({ url, width: rawWidth, height: rawHeight, fileName, mode = 'single', renderMetadata, onOpen }) => {
  const width = safeDimension(rawWidth, 1);
  const height = safeDimension(rawHeight, 1);
  const metadata = typeof renderMetadata === 'function' ? renderMetadata() : null;
  const frameClassName =
    mode === 'scroller' ? 'overflow-hidden rounded-2xl' : 'max-w-full overflow-hidden rounded-2xl md:max-h-96 md:max-w-96';

  return (
    <ImageFrame
      src={url}
      alt={fileName || 'PDF'}
      width={width}
      height={height}
      mode={mode}
      className={frameClassName}
      style={{ aspectRatio: `${width}/${height}` }}
      imgProps={{
        className: 'cursor-pointer rounded-2xl object-contain',
        onClick: onOpen,
      }}
    >
      {metadata}
    </ImageFrame>
  );
};

export default PdfAttachment;
